import { useMemo } from 'react';
import { useAppContext } from 'src/context/store/app-provider';
import { type StyleConfig } from 'src/types/style-config';

const DEFAULT_STYLE_CONFIG: StyleConfig = {
  hasBorder: true,
};

export const useStyleConfig = () => {
  const config = useAppContext();

  return useMemo(() => {
    return {
      ...DEFAULT_STYLE_CONFIG,
      ...(config.styleConfig ?? {}),
    };
  }, [config.styleConfig]);
};
